import { render } from "./ProfileInfoTitle.vue?vue&type=template&id=30b077d4"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "30b077d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30b077d4', script)) {
    api.reload('30b077d4', script)
  }
  
  module.hot.accept("./ProfileInfoTitle.vue?vue&type=template&id=30b077d4", () => {
    api.rerender('30b077d4', render)
  })

}

script.__file = "src/views/settings/pageTitles/ProfileInfoTitle.vue"

export default script